import { mapGetters } from 'vuex'
import { getStoredUserInfo, hasUserIdentity } from '@/utils/auth'

// 统一公共导航与积分页面的用户来源及经销商等级判断。
export default {
  computed: {
    ...mapGetters(['userInfo']),
    currentUser () {
      return hasUserIdentity(this.userInfo) ? this.userInfo : getStoredUserInfo()
    },
    isLoggedIn () {
      return hasUserIdentity(this.currentUser)
    },
    isIntegralUser () {
      return this.isLoggedIn && Number(this.currentUser.dealerLevel) === 1
    }
  }
}
